@if (isLoadingPolicies()) {
  <p class="policies-status" role="status">
    {{ 'app.patrol.roblox.cockpit.policies.loading' | translate }}
  </p>
} @else if (policiesError() === 'load_failed') {
  <p class="policies-status policies-status--error" role="alert">
    {{ 'app.patrol.roblox.cockpit.policies.loadError' | translate }}
  </p>
} @else {
  <div class="policies">
    @if (isSavingPolicies()) {
      <p class="policies-status" role="status">
        {{ 'app.patrol.roblox.cockpit.policies.saving' | translate }}
      </p>
    }
    @if (policiesError() === 'save_failed') {
      <p class="policies-status policies-status--error" role="alert">
        {{ 'app.patrol.roblox.cockpit.policies.saveError' | translate }}
      </p>
    }

    <section class="policies__section policies__section--guild">
      <div class="section-header-block">
        <h2 class="section-title">
          {{ 'app.patrol.roblox.cockpit.policies.universeSettings' | translate }}
        </h2>
        <p class="section-hint">
          {{ 'app.patrol.roblox.cockpit.policies.universeSettingsHint' | translate }}
        </p>
      </div>

      <div class="guild-settings">
        <div class="guild-settings__block">
          <label class="field field--inline">
            <span class="field__label">
              {{ 'app.patrol.roblox.cockpit.policies.defaultPreset' | translate }}
            </span>
            <select
              class="field__select"
              [ngModel]="settings().defaultPolicyId"
              (ngModelChange)="onDefaultPolicyChange($event)"
              [disabled]="isSavingPolicies()"
            >
              @for (preset of universeDefaultPresets; track preset) {
                <option [value]="preset">
                  {{ 'app.patrol.discord.cockpit.presets.' + preset | translate }}
                </option>
              }
            </select>
            @if (presetDescriptionKey(settings().defaultPolicyId); as descKey) {
              <p class="field__hint">{{ descKey | translate }}</p>
            }
          </label>
        </div>

        <div class="guild-settings__block">
          <p class="guild-settings__group-label">
            {{ 'app.patrol.roblox.cockpit.policies.universeOptions' | translate }}
          </p>
          <div class="guild-settings__toggles">
            <label class="toggle-field">
              <input
                type="checkbox"
                [checked]="settings().linkRequired"
                (change)="onToggle('linkRequired', $any($event.target).checked)"
                [disabled]="isSavingPolicies()"
              />
              <span class="toggle-field__copy">
                <span class="toggle-field__label">
                  {{ 'app.patrol.roblox.cockpit.policies.linkRequired' | translate }}
                </span>
                <span class="toggle-field__hint">
                  {{ 'app.patrol.roblox.cockpit.policies.linkRequiredHint' | translate }}
                </span>
              </span>
            </label>

            <label class="toggle-field">
              <input
                type="checkbox"
                [checked]="settings().reputationEnabled"
                (change)="onToggle('reputationEnabled', $any($event.target).checked)"
                [disabled]="isSavingPolicies()"
              />
              <span class="toggle-field__copy">
                <span class="toggle-field__label">
                  {{ 'app.patrol.roblox.cockpit.policies.reputationEnabled' | translate }}
                </span>
                <span class="toggle-field__hint">
                  {{ 'app.patrol.roblox.cockpit.policies.reputationEnabledHint' | translate }}
                </span>
              </span>
            </label>

            <label class="toggle-field">
              <input
                type="checkbox"
                [checked]="settings().failClosedOnAiOutage"
                (change)="onToggle('failClosedOnAiOutage', $any($event.target).checked)"
                [disabled]="isSavingPolicies()"
              />
              <span class="toggle-field__copy">
                <span class="toggle-field__label">
                  {{ 'app.patrol.roblox.cockpit.policies.failClosed' | translate }}
                </span>
                <span class="toggle-field__hint">
                  {{ 'app.patrol.roblox.cockpit.policies.failClosedHint' | translate }}
                </span>
              </span>
            </label>

            <label class="toggle-field">
              <input
                type="checkbox"
                [checked]="settings().notificationsEmail"
                (change)="onToggle('notificationsEmail', $any($event.target).checked)"
                [disabled]="isSavingPolicies()"
              />
              <span class="toggle-field__copy">
                <span class="toggle-field__label">
                  {{ 'app.patrol.roblox.cockpit.policies.notifications' | translate }}
                </span>
                <span class="toggle-field__hint">
                  {{ 'app.patrol.roblox.cockpit.policies.notificationsHint' | translate }}
                </span>
              </span>
            </label>
          </div>
        </div>

        <div class="guild-settings__block">
          <p class="guild-settings__group-label">
            {{ 'app.patrol.roblox.cockpit.policies.kindSpeechGroup' | translate }}
          </p>
          <p class="section-hint guild-settings__group-hint">
            {{ 'app.patrol.roblox.cockpit.policies.kindSpeechGroupHint' | translate }}
          </p>
          <p class="section-hint guild-settings__defaults-hint">
            {{
              'app.patrol.roblox.cockpit.policies.kindSpeechDefaults' | translate: kindSpeechDefaultParams
            }}
          </p>
          <div class="guild-settings__toggles">
            <label class="toggle-field">
              <input
                type="checkbox"
                [checked]="settings().kindSpeechEnabled"
                (change)="onToggle('kindSpeechEnabled', $any($event.target).checked)"
                [disabled]="isSavingPolicies()"
              />
              <span class="toggle-field__copy">
                <span class="toggle-field__label">
                  {{ 'app.patrol.roblox.cockpit.policies.kindSpeechEnabled' | translate }}
                </span>
                <span class="toggle-field__hint">
                  {{ 'app.patrol.roblox.cockpit.policies.kindSpeechEnabledHint' | translate }}
                </span>
              </span>
            </label>
          </div>
          <dl class="kind-speech-defaults">
            <div class="kind-speech-defaults__row">
              <dt>
                {{ 'app.patrol.roblox.cockpit.policies.kindSpeechMilestoneCount' | translate }}
              </dt>
              <dd>{{ kindSpeechDefaultParams.milestone }}</dd>
            </div>
            <div class="kind-speech-defaults__row">
              <dt>
                {{
                  'app.patrol.roblox.cockpit.policies.positiveParticipationHourlyLimit'
                    | translate
                }}
              </dt>
              <dd>{{ kindSpeechDefaultParams.hourlyLimit }}</dd>
            </div>
            <div class="kind-speech-defaults__row">
              <dt>
                {{ 'app.patrol.roblox.cockpit.policies.kindSpeechPenaltyCooldown' | translate }}
              </dt>
              <dd>{{ kindSpeechDefaultParams.penaltyMinutes }}</dd>
            </div>
            <div class="kind-speech-defaults__row">
              <dt>
                {{ 'app.patrol.roblox.cockpit.policies.kindSpeechDedupeWindow' | translate }}
              </dt>
              <dd>{{ kindSpeechDefaultParams.dedupeMinutes }}</dd>
            </div>
          </dl>
        </div>
      </div>
    </section>

    <section class="policies__section">
      <h2 class="section-title">
        {{ 'app.patrol.roblox.cockpit.policies.channelPolicies' | translate }}
      </h2>
      <p class="section-hint">
        {{ 'app.patrol.roblox.cockpit.policies.channelPoliciesHint' | translate }}
      </p>

      @if (discordChannels().length > 0) {
        <div class="table-wrap">
          <table class="policy-table policy-table--channels">
            <thead>
              <tr>
                <th>{{ 'app.patrol.roblox.cockpit.policies.colChannel' | translate }}</th>
                <th>{{ 'app.patrol.roblox.cockpit.policies.colPolicy' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (channel of discordChannels(); track channel.discordChannelId) {
                <tr>
                  <td>{{ channel.channelName }}</td>
                  <td>
                    <select
                      class="field__select field__select--compact"
                      [ngModel]="channelPolicyValue(channel.discordChannelId)"
                      (ngModelChange)="onChannelPolicyChange(channel.discordChannelId, $event)"
                      [disabled]="isSavingPolicies()"
                    >
                      @for (preset of channelPresets; track preset) {
                        <option [value]="preset">
                          @if (preset === 'inherit') {
                            {{ 'app.patrol.roblox.cockpit.policies.inheritUniverseDefault' | translate }}
                          } @else {
                            {{ 'app.patrol.discord.cockpit.presets.' + preset | translate }}
                          }
                        </option>
                      }
                    </select>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      } @else {
        <p class="empty-hint">
          {{ 'app.patrol.roblox.cockpit.policies.noChannels' | translate }}
        </p>
      }
    </section>
  </div>
}
